import React, { useEffect, useState, Fragment } from "react";
import { useSelector } from "react-redux";
import Bowser from "bowser";

import Phaser from "phaser";
import Scene1 from "./Scenes/Scene1_Cover";
import Scene2 from "./Scenes/Scene2_Introduction";
import Scene3 from "./Scenes/Scene3_GameStart";
import Ending from "./Scenes/EndingScene";

// import preload from "./Scenes/Loading";
import GameViewModel from "./ViewModels/GameViewModel";
// import emitter from "./Events/EventManager";
// import { CHOOSE_TC, CHOOSE_SC, CHOOSE_EN } from "./Events/Events";
import Scene1Overlay from "../Component/Scene1Overlay.jsx";
import Scene2Overlay from "../Component/Scene2Overlay.jsx";
import Scene3Overlay from "../Component/Scene3Overlay.jsx";
import EndingSceneOverlay from "../Component/EndingSceneOverlay.jsx";

// Add by Chris for showing the unsupport message for IE.
import logoImg from "./assets/B__V8_0000V2.png";

const oriCoverSize = { width: 1920, height: 1080 };

export let game;
export let gameVM;
export let canvas;

export function resize() {}

export default function Game() {
  const currentScene = useSelector((state) => {
    return state.currentScene.currentScene;
  });

  const [viewSize, setViewSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [coverSize, setCoverSize] = useState({
    width: oriCoverSize.width,
    height: oriCoverSize.height,
  });

  // Add by Chris for showing the unsupport message for IE.
  const browser = Bowser.getParser(window.navigator.userAgent);
  const isNotSupported = browser.satisfies({
    windows: {
      "internet explorer": "<=11",
    },
  });
  //******************************************************** */

  const updateSize = () => {
    setViewSize({ width: window.innerWidth, height: window.innerHeight });

    const screenRatio = window.innerWidth / window.innerHeight;
    const oriRatio = oriCoverSize.width / oriCoverSize.height;

    if (screenRatio > oriRatio) {
      const ratio = window.innerHeight / oriCoverSize.height;
      const newSize = {
        width: oriCoverSize.width * ratio,
        height: oriCoverSize.height * ratio,
      };
      setCoverSize(newSize);
    } else {
      const ratio = window.innerWidth / oriCoverSize.width;
      const newSize = {
        width: oriCoverSize.width * ratio,
        height: oriCoverSize.height * ratio,
      };
      setCoverSize(newSize);
    }
  };

  useEffect(() => {
    window.onload = () => {
      resize();
    };
    window.addEventListener("resize", updateSize);
    window.addEventListener("orientationchange", updateSize);

    // Add by Chris for showing the unsupport message for IE.
    if (isNotSupported) {
      updateSize();
      return;
    }

    const config = {
      type: Phaser.AUTO,
      parent: "phaser-game",
      backgroundColor: 0xedf8f9,
      scale: {
        mode: Phaser.Scale.FIT,
        width: 1920,
        height: 1080,
        zoom: 1,
      },
      scene: [Scene1, Scene2, Scene3, Ending],
      // scene: [Scene3, Ending]
    };
    game = new Phaser.Game(config);
    gameVM = new GameViewModel();

    window.onload = () => {
      resize();
    };
    window.addEventListener("resize", updateSize);
    window.addEventListener("orientationchange", updateSize);

    return () => {
      game = null;
    };
  }, []);

  // Add by Chris for showing the unsupport message for IE.
  if (isNotSupported) {
    return (
      <Fragment>
        <div
          id="notSupported"
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            display: "flex",
            width: viewSize.width,
            height: viewSize.height,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              textAlign: "center",
              objectFit: "contain",
            }}
          >
            <img
              src={logoImg}
              style={{
                width: `${coverSize.width}px`,
                height: `${coverSize.height}px`,
              }}
            />
          </div>
        </div>
      </Fragment>
    );
  } else {
    return (
      <div>
        <div className="overlay">
          <SceneOverlay scene={currentScene} />
        </div>

        <div
          id="phaser-game"
          style={{ width: viewSize.width, height: viewSize.height }}
          className="phaser-game"
        ></div>
      </div>
    );
  }
}

function SceneOverlay(props) {
  switch (props.scene) {
    case "Scene1":
      return <Scene1Overlay />;
    case "Scene2":
      return <Scene2Overlay />;
    case "Scene3":
      return <Scene3Overlay />;
    case "Ending":
      return <EndingSceneOverlay />;
    default:
      return <div>to be added</div>;
  }
}
